import { render } from "./PlpBulkExpandButton.vue?vue&type=template&id=e47f31e4"
import script from "./PlpBulkExpandButton.vue?vue&type=script&lang=js"
export * from "./PlpBulkExpandButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__